import React, {ReactElement, useContext} from 'react';
import {Typography} from '@customink/pigment-react';
import StoreBanner from '../../components/StoreBanner';
import StoreHeader from '../../components/StoreHeader';
import StoreFooter from '../../components/StoreFooter';
import {MobileContext} from '../../containers/MobileProvider';
import './index.scss';

export interface Props {
  storeSlug: string;
}

const StoreClosed: React.FC<Props> = ({storeSlug}: Props): ReactElement => {
  const mobile = useContext(MobileContext);
  const storeLayoutClassnames = `store-layout closed${mobile ? ' mobile' : ''}`;

  return (
    <div className={storeLayoutClassnames}>
      <StoreHeader skipFetchProducts storeSlug={storeSlug} preview={false} />
      <div className="store-layout-body">
        <StoreBanner hideAlert storeSlug={storeSlug} />
        <Typography className="closedMessage" variant="h4">
          Sorry we missed you! We&apos;re not taking orders at this time.
        </Typography>
      </div>
      <StoreFooter storeSlug={storeSlug} preview={false} />
    </div>
  );
};

export default StoreClosed;
